import React, { useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { examinedData } from '../../../common/spdCore/contexts/ExaminedContext';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { GetExaminedDto } from '../../../common/spdCore/autogenerated/spdApiClient';

import { ExaminedEditor } from './ExaminedEditor';

export const ExaminedEditLink = (props: {
  examinedId: string;
  onSave?: () => void;
}) => {
  const spd = useSpdCore();
  const [show, setShow] = useState(false);
  const [examined, setExamined] = useState<GetExaminedDto | null | undefined>();

  const handleClick = () => {
    spd.examineds
      .getExamined(props.examinedId)
      .then(ex => setExamined(ex))
      .catch(() => {
        console.error('Error during get examined.');
      });
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  return (
    <>
      <OverlayTrigger overlay={<Tooltip>Edycja badanego</Tooltip>}>
        <Button
          onClick={e => {
            e.stopPropagation();
            handleClick();
          }}
          variant="btn-info"
        >
          <Icon.Pencil />
        </Button>
      </OverlayTrigger>
      {examined && (
        <ExaminedEditor
          id={props.examinedId}
          examined={examinedData(examined)}
          show={show}
          handleClose={handleClose}
          readOnly={false}
        />
      )}
    </>
  );
};
